module.exports = {"320105001":"莫愁湖街道","320105002":"沙洲街道","320105003":"双闸街道","320105004":"江心洲街道","320105006":"兴隆街道","320105007":"南苑街道","320105400":"建邺区新城科技园","320105401":"建邺区河西中央商务区","320105402":"建邺区江东商业文化旅游中心区","320105403":"中新南京生态科技岛"}


//////////////////
// WEBPACK FOOTER
// ./src/town/320105.json
// module id = 829
// module chunks = 0